import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IConsultReport } from 'containers/CourtManagerLegalProceedings/ExpertReport/typings';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision/messages';
import { DOCUMENT, PROCEDURE_STATUSES } from 'containers/data-structure';
import Document from 'components/Document';
import { handleOpenDocument } from 'services/utils';
import { formatExpertReportStatus } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';

export interface ExpertReportDecisionRecapProps {
  intl: IntlShape;
  status: string;
  validator: string;
  rejectionReason: string;
  report: IConsultReport;
  requestGetDocByDocumentumId: Function;
}

export const ExpertReportDecisionRecap: React.FC<ExpertReportDecisionRecapProps> = (
  props,
): JSX.Element => {
  const status = formatExpertReportStatus(props.status)
    ? translate(formatExpertReportStatus(props.status), props)
    : '';

  return (
    <section className="expert-report-decision-recap-container">
      <h4 className="decision-recap-container-title">
        {translate(messages.decisionRecapTitle, props)}
      </h4>
      <article className="decision-status">
        <span className="decision-sub-bloc-title">
          {translate(messages.courtManagerExpertReportDecision, props)}
        </span>
        <span>{status}</span>
      </article>
      {props.status === STATUS_REJECTED && (
        <article className="decision-status">
          <span className="decision-sub-bloc-title">
            {translate(messages.rejectionReason, props)}
          </span>
          <span>{props.rejectionReason}</span>
        </article>
      )}
      {props.validator && <ValidatorRecap validator={props.validator} />}
      <article className="contest-decision-recap">
        {!isEmpty(get(props.report, DOCUMENT.URL)) && (
          <div className="decision-document">
            <Document
              name={get(props.report, DOCUMENT.NAME)}
              type={get(props.report, DOCUMENT.TYPE)}
              icon={
                <VisibilityIcon
                  className="consult"
                  onClick={handleOpenDocument(
                    props.report as any,
                    props.requestGetDocByDocumentumId,
                  )}
                />
              }
            />
          </div>
        )}
        {props.status === PROCEDURE_STATUSES.CONTESTED && (
          <div className="contest-reason">
            <span className="decision-sub-bloc-title">
              {translate(
                messages.courtManagerExpertReportDecisionContestReason,
                props,
              )}
            </span>
            <span> {get(props.report, 'disputeReason')}</span>
          </div>
        )}
      </article>
    </section>
  );
};

export default injectIntl(ExpertReportDecisionRecap);
